import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import Layout from "components/Layout";
import Hero from "components/Hero";
import { Container } from "components/Grid";
import { ActionBlock, VideoBlock } from "components/Block";
import LatestArticles from "components/LatestArticles";

import Teams from "./Teams";
import Map from "./Map";

export const TeamPageTemplate = ({ page }) => {
  return (
    <>
      <Hero
        pb={["50px", "50px", "80px", "110px"]}
        content={page.hero}
        shade="light"
      />
      <Container pb={["40px", "70px"]} display="block" bg="white">
        <Teams content={page.teams} />
      </Container>
      <Container mt={["-200px", "-200px"]} display="block" overflow="hidden">
        <Map content={page.map} />
        <ActionBlock content={page.cta} shade="light" />
      </Container>
    </>
  );
};

// TeamPageTemplate.propTypes = {
//   title: PropTypes.string
// };

const TeamPage = ({ data }) => {
  const { frontmatter: page } = data.markdownRemark;
  return (
    <Layout page={page} shade="dark" footerShade="dark">
      <TeamPageTemplate page={page} />
    </Layout>
  );
};

TeamPage.propTypes = {
  data: PropTypes.object.isRequired
};

export default TeamPage;

export const teamPageQuery = graphql`
  query TeamPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        page {
          title
        }
        hero {
          heading
          subheading
          buttonText
          buttonPath
          image {
            childImageSharp {
              fluid(maxWidth: 1000, quality: 100) {
                ...GatsbyImageSharpFluid_noBase64
              }
            }
          }
        }
        teams {
          name
          people {
            name
            role
            bio
            github
            twitter
            linkedin
            image {
              childImageSharp {
                fluid(maxWidth: 400, quality: 100) {
                  ...GatsbyImageSharpFluid_noBase64
                }
              }
            }
          }
        }
        map {
          heading
          subheading
          image {
            childImageSharp {
              fluid(maxWidth: 1600, quality: 100) {
                ...GatsbyImageSharpFluid_noBase64
              }
            }
          }
        }
      }
    }
  }
`;
